// src/utils/date-shim
//
// Drop-in replacement for `moment`, backed by dayjs.
// Migration strategy: replace `from 'moment'` with `from '@/utils/date-shim'`
// (or the relative path to this file) across the codebase. Most call sites
// keep working unchanged because dayjs mirrors moment's API closely.
//
// IMPORTANT — dayjs objects are immutable, moment objects are not.
//   moment: a.add(1, 'day')       // mutates `a` in place
//   dayjs:  a = a.add(1, 'day')   // returns a new instance, must reassign
// Any code relying on in-place mutation will silently produce wrong
// results, not throw — audit `.add(`/`.subtract(` call sites that don't
// reassign or chain further.

import dayjs from 'dayjs'

import utc from 'dayjs/plugin/utc'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import minMax from 'dayjs/plugin/minMax'

dayjs.extend(utc)
dayjs.extend(isSameOrBefore)
dayjs.extend(isSameOrAfter)
dayjs.extend(minMax)

// If the app ever sets a non-English locale via moment.locale('xx'),
// mirror it here, e.g.:
// import 'dayjs/locale/fr'
// dayjs.locale('fr')

export default dayjs

export { dayjs as moment }
